// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/akash.css
// module id = 1281
// module chunks = 34